import { type SVGProps, useId } from "react";

export function NavLeftIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Collapse navigation</title>
			<path
				d="M2 12.6663V3.33301M8.66667 3.99967L4.66667 7.99967M4.66667 7.99967L8.66667 11.9997M4.66667 7.99967H14"
				stroke="#737373"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
